var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "container-fluid section-div" },
        [
          _c("div", { staticClass: "section-title-div section-title-div-1" }, [
            _vm._m(0),
            _c("span", { staticClass: "section-title-1" }, [
              _vm._v(_vm._s(_vm.$t("build_your_jewel.title")) + " ")
            ]),
            _vm._m(1)
          ]),
          _vm.showMessage && !_vm.expired
            ? _c("b-alert", { attrs: { variant: "warning", show: "" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("build_your_jewel.free_trial", [_vm.expiryDate])
                  ) + " "
                )
              ])
            : _vm._e(),
          _c("div", { staticClass: "relative-div" }, [
            _vm.showMessage && _vm.expired
              ? _c("div", { staticClass: "overlay" }, [
                  _c(
                    "div",
                    { staticClass: "overlay-content" },
                    [
                      _c(
                        "b-alert",
                        { attrs: { variant: "warning", show: "" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("build_your_jewel.free_trial_expired", [
                                _vm.expiryDate
                              ])
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "row m-0 d-flex justify-content-center pb-3" },
              [
                _vm._l(_vm.stonesNumberOptions, function(option) {
                  return _c("div", { staticClass: "col-6 col-md-4 col-lg-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "stone-number-option",
                        class: {
                          "selected-stone-number-option":
                            _vm.selectedStonesNumber == option.value
                        },
                        on: {
                          click: function($event) {
                            return _vm.selectStonesNumber(option)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "option-icons" },
                          _vm._l(option.value, function(index) {
                            return _c(
                              "svg",
                              {
                                key: index,
                                staticClass: "option-icon",
                                attrs: {
                                  width: "100%",
                                  height: "100%",
                                  viewBox: "0 0 79 99",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M39 2L2 49.5L39 96.5L77.5 49.5L39 2Z"
                                  }
                                })
                              ]
                            )
                          }),
                          0
                        ),
                        _c("div", { staticClass: "option-text" }, [
                          _vm._v(_vm._s(option.text))
                        ])
                      ]
                    )
                  ])
                }),
                _c("div", { staticClass: "col-6 col-md-4 col-lg-3" }, [
                  _c(
                    "div",
                    {
                      staticClass: "stone-number-option",
                      on: {
                        click: function($event) {
                          return _vm.goToPreconfigured()
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "preconfigured-option" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "preconfigured-icon",
                            attrs: {
                              viewBox: "0 0 260 72",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M36 2H224L256 36L224 70H36L4 36L36 2Z"
                              }
                            })
                          ]
                        ),
                        _c("span", { staticClass: "preconfigured-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("build_your_jewel.preconfigured"))
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ],
              2
            ),
            _vm.chatbotEnabled
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-content-center pb-4" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "byj-ai-btn",
                        on: { click: _vm.openAIChatbot }
                      },
                      [_vm._v(" 🤖 Configura con AI ")]
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title-line-div" }, [
      _c("span", { staticClass: "section-title-line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title-line-div" }, [
      _c("span", { staticClass: "section-title-line" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }